import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_global_header = _resolveComponent("global-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_park = _resolveComponent("park")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isHeader)
      ? (_openBlock(), _createBlock(_component_global_header, {
          key: 0,
          onOpen: _ctx.globalMenu
        }, null, 8, ["onOpen"]))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view, {
      onHeader: _ctx.header,
      onContentShow: _ctx.show,
      onStart: _ctx.start
    }, null, 8, ["onHeader", "onContentShow", "onStart"]),
    _createVNode(_component_park, {
      isShow: _ctx.isShow,
      isStart: _ctx.isStart,
      isGlobalMenu: _ctx.isGlobalMenuOpen
    }, null, 8, ["isShow", "isStart", "isGlobalMenu"])
  ], 64))
}